import React from "react";

export const MapCenterContext = React.createContext({
  mapCenter: [0, 0], // Initial position
  setMapCenter: (center: [number, number]) => {}, // Initial setter
});
